/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TopMenuController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class TopMenuController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class TopMenuController extends cls.ControllerBase /** @lends classes.TopMenuController.prototype */ {
    static __name = "TopMenuController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      if (this.getAnchorNode().getParentNode().getTag() === "Form") {
        this._addBehavior(cls.FormRelatedHiddenVMBehavior);
      }
      this._addBehavior(cls.BackgroundColorVMBehavior);
    }

    /**
     * Defines widget as TopMenu or StartMenu depending of topmenuMobileRendering/topmenuDesktopRendering style rendering
     * @param kind
     * @return {string}
     * @private
     */
    _getWidgetType(kind) {
      let type;
      if (!kind) {
        const windowNode = this.getAnchorNode().getAncestor("Window") || this.getAnchorNode().getApplication().getVMWindow();
        if (windowNode) {
          kind = cls.WindowHelper.isMobile() ? "sidebar" : "classic"; // default values
          let styleRendering = cls.WindowHelper.isMobile()
            ? windowNode.getStyleAttribute("topmenuMobileRendering")
            : windowNode.getStyleAttribute("topmenuDesktopRendering");
          if (styleRendering) {
            // if 4ST is set, then override default values
            kind = styleRendering;
          }
        }
      }
      if (kind === "sidebar" && context.MainContainerService.isChromeBarVisible() && !context.ApplicationListService.isApplicationListInChromeBar()) {
        // in sidebar, we want collapse/expand mechanism and this is why we generate startmenu
        type = "StartMenu";
      } else {
        type = "TopMenu";
      }

      return type;
    }

    /**
     * @inheritDoc
     */
    attachUI() {
      context.TopMenuService.add(this.getAnchorNode());
    }

    /**
     * @inheritDoc
     */
    detachUI() {
      context.TopMenuService.remove(this.getAnchorNode());
      super.detachUI();
    }
  }

  cls.TopMenuController = TopMenuController;
  cls.ControllerFactory.register("TopMenu", cls.TopMenuController);
});
